import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from "recharts";
import { useTranslation } from "react-i18next";

const COLORS = { errors: "#ef4444", warnings: "#f59e0b", info: "#3b82f6" };

const SecurityFindingsChart = ({ projects }) => {
    const { t } = useTranslation();
    const scanned = projects.filter((p) => p.grade);

    if (scanned.length === 0) {
        return (
            <div className="flex items-center justify-center h-48 text-muted-foreground text-sm">
                {t("security.noScansYet")}
            </div>
        );
    }

    const data = scanned.slice(0, 8).map((p) => ({
        name: p.name?.length > 12 ? p.name.slice(0, 12) + "..." : p.name,
        errors: p.errorCount,
        warnings: p.warningCount,
        info: p.infoCount,
    }));

    return (
        <ResponsiveContainer width="100%" height={200}>
            <BarChart data={data} margin={{ top: 5, right: 10, left: -10, bottom: 5 }}>
                <XAxis dataKey="name" tick={{ fontSize: 11 }} />
                <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
                <Tooltip />
                <Bar dataKey="errors" stackId="a" name={t("security.errors")} fill={COLORS.errors} radius={[0, 0, 0, 0]} />
                <Bar dataKey="warnings" stackId="a" name={t("security.warnings")} fill={COLORS.warnings} />
                <Bar dataKey="info" stackId="a" name={t("security.infoLabel")} fill={COLORS.info} radius={[3, 3, 0, 0]} />
            </BarChart>
        </ResponsiveContainer>
    );
};

export default SecurityFindingsChart;
